import { render, staticRenderFns } from "./BlogMobile.vue?vue&type=template&id=b276678e&scoped=true"
import script from "./BlogMobile.vue?vue&type=script&lang=js"
export * from "./BlogMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b276678e",
  null
  
)

export default component.exports